import { IPendingInvoice } from "../../../interfaces";
import { urlHttpGov } from "../../urls";
import privateHttpClient from "../privateHttpClient";

export interface IListPendingInvoicesFilters {
    cityId: number;
    page?: number;
    size?: number;
    sort?: string;
    order?: 'asc' | 'desc';
    user?: string;
    name?: string;
    cpf?: string;
    person?: string;
    company?: string;
    cnpj?: string;
    cpfCnpj?: string;
    status?: string | string[];
    type?: string;
    startPeriod?: string;
    endPeriod?: string;
    startDate?: string;
    endDate?: string;
    dateIssue?: string;
    date_issue?: string;
    createdAt?: string;
    created_at?: string;
    year?: number | string;
    signal?: AbortSignal;
}

export interface IListPendingInvoicesResponse {
    pending_invoices: IPendingInvoice[];
    invoices: IPendingInvoice[];
    total: number;
}

class PendingInvoicesService {
    private baseURL = `${urlHttpGov}/panel/pending-invoice`;

    async listPendingInvoices({
        cityId,
        page = 1,
        size = 10,
        sort,
        order,
        user,
        name,
        cpf,
        person,
        company,
        cnpj,
        cpfCnpj,
        status,
        type,
        startPeriod,
        endPeriod,
        startDate,
        endDate,
        dateIssue,
        date_issue,
        createdAt,
        created_at,
        year,
        signal,
    }: IListPendingInvoicesFilters): Promise<IListPendingInvoicesResponse> {
        const params: Record<string, any> = {
            page,
            size,
            sort,
            order,
            user,
            name,
            cpf,
            person,
            company,
            cnpj,
            cpfCnpj,
            status: Array.isArray(status) ? status.join(',') : status,
            type,
            startPeriod,
            endPeriod,
            startDate,
            endDate,
            dateIssue,
            date_issue,
            createdAt,
            created_at,
            year,
        };

        Object.keys(params).forEach(
            (key) => (params[key] === undefined || params[key] === null || params[key] === '') && delete params[key]
        );

        const queryString = new URLSearchParams(params).toString();
        const url = queryString ? `${this.baseURL}/${cityId}?${queryString}` : `${this.baseURL}/${cityId}`;

        const { data } = await privateHttpClient.get(url, { signal });

        return {
            pending_invoices: data.pending_invoices || data.invoices || (Array.isArray(data) ? data : []),
            invoices: data.invoices || data.pending_invoices || (Array.isArray(data) ? data : []),
            total: typeof data.total === 'number' ? data.total : (Array.isArray(data) ? data.length : (data.pending_invoices?.length || 0)),
        };
    }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new PendingInvoicesService();
